$(document).ready(function () {
    // objectFitImages();
    // mainNav.init();

    //Tooltip tippy
    tippy('.tooltip--top', {
        theme: 'hamaka',
        arrow: true,
        placement: 'top',
        allowTitleHTML: true,
    });
    tippy('.tooltip--right', {
        theme: 'hamaka',
        arrow: true,
        placement: 'right',
        allowTitleHTML: true,
    });

    $('.login__form--hide-label').on('input focusin', 'input', function () {
        $(this).closest('.field').find('label').hide();
    }).on('focusout', 'input', function () {
        if (!$(this).val())
        {
            $(this).closest('.field').find('label').show();
        }
    });

    //Datepicker orderpage
    $(function () {
        $("#datepicker").datepicker({
            minDate: 0
        });
    });

    $('.collapsible2 .collapsible2__trigger').click(function (e) {
        if (!$(this).parent().hasClass('collapsible2--open'))
        {
            var jsContent = $(this).parent().find('.collapsible2__content').first();
            jsContent.slideDown();
        }
        else
        {
            var jsContent = $(this).parent().find('.collapsible2__content').first();
            jsContent.slideUp();
        }
        $(this).parent().toggleClass('collapsible2--open');
    });
    /*		$('.collapsible2 .collapsible2__trigger').on('click', function (event) {
						$(this).find('.collapsible2__content').slideDown();
						$(this).parent().toggleClass('collapsible2--open');
				});*/

    $('.header__menu').on('click', function (event) {
        $('.header__compact .header__compact-menu').toggle();
    });

    $('.js-menu .js-menu__trigger').on('click', function (event) {
        var activate = !$(event.currentTarget).hasClass('secondary-nav__item--current')

        $('.js-menu .js-menu__trigger').removeClass('secondary-nav__item--current')
            .closest('.js-menu')
            .addClass('js-menu--collapsed')
            .find('.js-menu__content').hide();

        if (activate)
        {
            $(event.currentTarget)
                .addClass('secondary-nav__item--current')
                .closest('.js-menu')
                .removeClass('js-menu--collapsed')
                .find('.js-menu__content').show();
        }
    });


    //Card open/dicht klappen
    $('.btn-arrow-more').click(function (e) {
        $(this).toggleClass('active');
        if ($(this).hasClass('active'))
        {
            showCard($(this));
        }
        else
        {
            hideCard($(this));
        }
    });

    //Back to top button
    $(".legal__back-to-top").click(function () {
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });

    var hash = window.location.hash.substr(1);
    if (hash)
    {
        handleMultiForm(hash);
    }

    $('.multi-login').show();

    $('.multi-login__option').on('click', function (e) {
        var formId = $(e.target).data('form');
        handleMultiForm(formId);
    });

    //TODO Tijdelijke functie voor demo purpose only
    $('.header__logo a').click(function (e) {
        e.preventDefault();
        showSubsiteList($(this).parent());
    });
    //EINDE TIJDELIJKE FUNCTIE

	if ($('.JobsOverviewPage').length ||
		$('.FacilitiesPage').length ||
		$('.ImpressionsPage').length ||
		$('.ArrangementHolderPage').length ||
		$('.ProductHolderPage').length
	)
	{
		initGridSort();
	}
	$('.hasChildren').click(function (e) {
		e.preventDefault();
		$(this).removeClass('hasChildren');
	});
});


function handleMultiForm(formId)
{
    var loginForm = $('.multi-login').find('#' + formId);
    if (loginForm.length > 0)
    {
        $('.multi-login__options').hide();
        $('.multi-login__form').hide();
        loginForm.show();
    }
}

function showCard(elem)
{
	elem.parents('.card').find('.card__content__description').addClass('toggled-card');
}

function hideCard(elem)
{
	elem.parents('.card').find('.card__content__description').removeClass('toggled-card');
}

//TODO tijdelijke functies om makkelijk te switchen van subsite
function showSubsiteList(logo)
{
    if (!logo.hasClass('enabled'))
    {
        logo.addClass('enabled').append('<div class="switchWrap"><a class="quickSelect" onclick="changeSubsite(1)"><img src="/_resources/app/client/images/devarana_logo.jpg"></a><a class="quickSelect" onclick="changeSubsite(2)"><img src="/_resources/app/client/images/ridderrode_logo.jpg"></a><a class="quickSelect" onclick="changeSubsite(3)"><img src="/_resources/app/client/images/den_ilp_logo.jpg"></a></div>');
        logo.find('select').slideDown(200);
    }
    else
    {
        logo.removeClass('enabled').find('.switchWrap').remove();
    }
}

function changeSubsite(subsiteID)
{
    var clean_uri = location.protocol + "//" + location.host + location.pathname;
    window.history.replaceState({}, document.title, clean_uri);
    window.location.href = (clean_uri + '?design=' + subsiteID);
}

//EINDE TIJDELIJKE FUNCTIES


function initGridSort()
{
    var $grid = $('.main__content-grid').isotope({
        // options
        itemSelector: '.page-grid__cell',
        layoutMode: 'packery',
        originLeft: true,
        hiddenStyle: {
            opacity: 0
        },
        visibleStyle: {
            opacity: 1
        }
    });
    $('.btn-arrow-more').click(function (e) {

		$grid.isotope('layout');

	});

	$('.filters__item .btn').on('click', function () {
		var activeClass = 'btn-sort--state-active';
		if ($(this).hasClass('btn-sort--state-active'))
		{
			$(this).removeClass(activeClass);
			var filterValue = '';
		}
		else
		{
			$('.filters').find('.' + activeClass).removeClass(activeClass);
			$(this).addClass(activeClass);
			var filterValue = $(this).attr('data-filter');
		}
		$grid.isotope({filter: filterValue});
	});

    function loadMore($grid)
    {
        var $items = $('.impression__container--hidden').find('.impression__item:lt(5)').removeClass('impression__item');
        if (!$('.impression__item').length)
        {
            $('.btn-more').remove();
        }
        var $itemsClone = $items.clone();
        $grid.append($itemsClone).isotope('appended', $itemsClone);
    }

    loadMore($grid); //init
    $('.btn-more').click(function () {
        loadMore($grid);
    });

}